export default "__VITE_ASSET__BkrzVdkz__"